var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentlySold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1254_1019)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1254_1019)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84691 1.8469C1.33792 1.8469 0.923462 1.43244 0.923462 0.92345C0.923462 0.414462 1.33792 0 1.84691 0H22.1555C22.6621 0 23.0766 0.414462 23.0766 0.92345C23.0766 1.43244 22.6621 1.8469 22.1531 1.8469H21.2297V3.6938C22.2501 3.6938 23.0766 4.5203 23.0766 5.5407V12.9259C23.0766 13.9463 22.2501 14.7728 21.2297 14.7728H8.30864C7.28824 14.7728 6.46174 13.9463 6.46174 12.9259V5.53828C6.46174 4.51788 7.28824 3.69138 8.30864 3.69138V1.8469H4.61484V23.0765C4.61484 23.5855 4.20038 24 3.69139 24C3.1824 24 2.77036 23.5855 2.77036 23.0765V1.8469H1.84691ZM10.1531 3.69138H19.3828V1.8469H10.1531V3.69138Z",
    fill: "#FF95B4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1254_1019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1254_1019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlySold);
export default __webpack_public_path__ + "static/media/recentlySold.89123749a96d780ef1af725750eb5568.svg";
export { ForwardRef as ReactComponent };